import 'css/src/components/common/dashboard-trim.module.scss';

import React from 'react';
import classNames from 'classnames';

import { CookieBanner } from './cookie-policy/CookieBanner';
import { AnnouncementPopup } from './AnnouncementPopup';

import type { ChannelEnum } from 'js/src/client';
import AnimationMinutesIntroModal from 'js/src/components/animated-explainer-videos/components/AnimationMinutesIntroModal';
import DashboardHeader from 'js/src/components/common/DashboardHeader';
import DashboardSidebar from 'js/src/components/common/DashboardSidebar';
import SettingsSidebar from 'js/src/components/common/SettingsSidebar';
import PageErrorBoundary from 'js/src/components/common/ui/ErrorBoundary';

type Props = {
    sidebar: 'none' | 'dashboard' | 'settings'; // what sidebar view to show
    children?: React.ReactNode;
    className?: string;
    feedbackChannel?: ChannelEnum;
};

const DashboardTrim = React.memo(function DashboardTrim({
    sidebar,
    children,
    className,
    feedbackChannel,
}: Props) {
    let sidebar_node = null;
    // show the sidebar by default, so only reset it if it's explicitly set to `false`
    if (sidebar === 'dashboard') {
        sidebar_node = <DashboardSidebar />;
    } else if (sidebar === 'settings') {
        sidebar_node = <SettingsSidebar />;
    }
    return (
        <div
            className={classNames('dashboard-trim', className, {
                'has-sidebar': sidebar !== 'none',
            })}
        >
            <PageErrorBoundary>
                <CookieBanner floating />

                {sidebar_node}

                <div className="page-container">
                    <DashboardHeader
                        hasSidebar={sidebar !== 'none'}
                        feedbackChannel={feedbackChannel}
                    />
                    <div className="page-content">
                        <div
                            className={classNames('content', {
                                'has-sidebar': sidebar !== 'none',
                            })}
                        >
                            {children}
                        </div>
                    </div>
                </div>
            </PageErrorBoundary>
            <AnnouncementPopup />
            <AnimationMinutesIntroModal />
        </div>
    );
});

export default DashboardTrim;
